import type { ErrorPayload } from '@atlaskit/report-error';
import { reportError } from '@jira/platform__error-boundary/src/ErrorBoundary.tsx';

export function platformErrorHandler(payload: ErrorPayload): void {
	reportError(payload.error, payload.errorInfo, { id: payload.interactionId });
}
